import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PropsWithChildren, ReactNode } from 'react';

import { PoolButton } from '../button/pool-button';
import { PoolModal } from '../modal/pool-modal';

export interface ConfirmationDialogProps {
    isVisible: boolean;
    title?: ReactNode;
    action?: ReactNode;
    isSuccessDialog?: boolean;
    onConfirm: () => void;
    onCancel?: () => void;
    cancelText?: ReactNode;
    hasModalTypography?: boolean;
}

export const ConfirmationDialog = (props: PropsWithChildren<ConfirmationDialogProps>) => {
    const { isVisible, onConfirm, onCancel, cancelText, action, title, isSuccessDialog, children, hasModalTypography } =
        props;

    const actionChildren = [
        <PoolButton
            key="2"
            color={isSuccessDialog ? 'primary' : 'secondary'}
            styleType="firstLevel"
            onClick={onConfirm}
            autoFocus={true}
        >
            {action || <FormattedMessage id="app.common.yes" />}
        </PoolButton>,
    ];

    if (onCancel) {
        actionChildren.unshift(
            <PoolButton key="1" color="primary" variant="text" styleType="firstLevel" onClick={onCancel}>
                {cancelText || <FormattedMessage id="app.common.cancel" />}
            </PoolButton>
        );
    }

    return (
        <PoolModal
            isVisible={isVisible}
            title={title || <FormattedMessage id={'app.common.modal.warningHeader'} />}
            handleClose={onCancel}
            actionChildren={actionChildren}
            actionChildrenCentered={!!onCancel}
            hasModalTypography={hasModalTypography}
        >
            <Box>{children || <FormattedMessage id="app.common.modal.warning" />}</Box>
        </PoolModal>
    );
};
